import { Component, ChangeDetectionStrategy} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'custom-icon-action-cell',
  template: `<button
    class="grid-icon-button"
    (click)="invokeParentMethod()"
    disableRipple="true"
    [disabled]="params.disabled"
    mat-icon-button *ngIf="params">
    <i [ngClass]="params.iconClass"></i>
  </button>`,
})

export class CustomIconActionRendererComponent implements ICellRendererAngularComp {
  public params: any;

  agInit(params: any): void {
    this.params = params;
    if (typeof this.params.disabled === "function") {
      this.params.disabled = this.params.disabled();
    }
  }

  public invokeParentMethod() {
    if (this.params.actionName) {
      if (this.params.actionName === "manageDashboardCellEdit") {
        this.params.context.componentParent[this.params.actionName](this.params);
      }
      else {
        this.params.context.componentParent[this.params.actionName](this.params.node.data);
      }

    } else {
      this.params.context.componentParent.customAction(this.params.node.data);
    }
  }

  refresh(): boolean {
    return false;
  }
}
